<template>
  <div class="page-container">
    <!-- start page content -->
    <div class="page-content">
      <!-- begin:: Header Mobile -->
      <KTHeaderMobile></KTHeaderMobile>
      <!-- end:: Header Mobile -->

      <Loader class="loaderLogo" v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

      <!-- begin::Body -->
      <div class="page-inner">
        <!-- begin:: Header -->

        <KTHeader></KTHeader>

        <!-- end:: Header -->

           <!-- begin:: Content Body -->
          <div id="begin" class="d-flex flex-column-fluid">
            
              <div class="wrap">
                <!-- begin:: Aside Left -->
                <KTAside v-if="asideEnabled"></KTAside>
                <!-- end:: Aside Left -->
                  <transition name="fade-in-up" @after-enter="scrollTop" appear>
                    <router-view />
                  </transition>
              </div>
          </div>
          <!-- end:: Content Body -->
        </div>
<!-- 
        <transition name="fade">
          <div v-show="mostrarChatBot" class="panel-chatbot">
            <ChatBot :mostrarChatBot="mostrarChatBot"> </ChatBot>
          </div>
        </transition>

        <div class="botonChatBot" v-show="botonChatBot">
          <img
            src="/media/img/avatar.png"
            alt=""
            @click="(mostrarChatBot = true), (botonChatBot = false)"
          />
        </div> -->

      <KTFooter v-if="footerLayout('compact')"> </KTFooter>
      <FooterExtended v-if="footerLayout('extended')"> </FooterExtended>
    </div>

    <KTScrollTop></KTScrollTop>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isMobile } from 'mobile-device-detect';
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import FooterExtended from "@/view/layout/footer/FooterExtended.vue";
import HtmlClass from "@/core/services/htmlclass.service";
// import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

export default {
  name: "Layout",
  components: {
    // ChatBot,
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    FooterExtended,
    // KTSubheader,
    KTScrollTop,
    Loader,
  },
  data() {
    return {
      mostrarChatBot: false,
      botonChatBot: true,
    };
  },
  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  created() {
    this.$bus.$on("cerrarChatBot", (resultado) => {
      this.mostrarChatBot = resultado;
      this.botonChatBot = true;
    });
  },
  mounted() {
    setTimeout(() => {
      this.mostrarChatBot = true;
      this.botonChatBot = false;
    }, 2000);
    // check if current user is authenticated
    if (!this.isAuthenticated) {
      //this.$router.push({ name: "login" });
    }
    // Simulate the delay page loading
    setTimeout(() => {
      // Remove page loader after some time
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2000);
  },
  methods: {
    scrollTop(){
      console.log('mobile ' + isMobile);
      if(isMobile){
        let element = document.getElementById('begin');
        if(element)
          element.scrollIntoView({behavior: 'smooth'})
        }
    },
    footerLayout(type) {
      return this.layoutConfig("footer.layout") === type;
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap{
  width: 100%;
}
#begin{
  justify-content: center;
}

.page-inner{
  min-height: 90vh;
}
.content-body{
  margin: 0 auto !important;
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.panel-chatbot {
  z-index: 9999999;
  position: fixed;
  bottom: 0;
  height: 516px;
  right: 10px;
  box-shadow: 0 0 10px #ccc;
}
.botonChatBot {
  z-index: 9999999;
  position: fixed;
  bottom: 10px;
  width: 50px;
  height: 50px;
  right: 10px;
}

.botonChatBot img {
  width: 50px;
  height: 50px;
}

@keyframes float {
  0% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    transform: translatey(0px);
  }
  50% {
    box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
    transform: translatey(-20px);
  }
  100% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    transform: translatey(0px);
  }
}

.banner-km,
.banner-km-mobile {
  box-sizing: border-box;
  border-radius: 0%;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 rgba(0, 0, 0, 0.6);
  transform: translatey(0px);
  /*animation: float 6s ease-in-out infinite;*/
  img {
    width: 100%;
    height: auto;
  }
}
</style>